import { pdfReportTypes, TValidPdfReportKeys } from '../../../../ng2/shared/constants/pdf-reports.constant';

angular.module('nv.shared.modals').factory('StudentReportModal', studentReportModalFactory);

const State = {
  NOT_STARTED: 'NOT_STARTED',
  GENERATING: 'GENERATING',
  READY: 'READY',
};

function studentReportModalFactory($mdDialog, ErrorModal, backgroundJob, $window) {
  let StudentReportModal = {
    show(selectedStudentIds, reportName: TValidPdfReportKeys) {
      return $mdDialog.show({
        clickOutsideToClose: true,
        template: require('./student-report-modal.html'),
        parent: angular.element(document.body),
        locals: {
          selectedStudentIds,
          reportName,
        },
        controller($scope, selectedStudentIds, Report, UtilitiesService, reportName) {
          $scope.reportHumanName = pdfReportTypes[reportName];
          $scope.report = new Report({
            _id: UtilitiesService.createV4Uuid(),
            reportName,
            studentIds: selectedStudentIds,
            userProvidedFilename: 'students.pdf',
          });

          $scope.countStudents = selectedStudentIds.length;

          $scope.state = State.NOT_STARTED;

          $scope.generate = () => {
            $scope.state = State.GENERATING;
            $scope.report.$create(
              (report, headers) => {
                $scope.backgroundJobPromise = backgroundJob(headers('nv-background-jobs')).promise();
                $scope.backgroundJobPromise.then(() => {
                  $scope.report.$get(report => {
                    $scope.state = State.READY;
                    $scope.downloadUrl = report._downloadUrl;
                  });
                });

                $scope.backgroundJobPromise.catch(error => {
                  handleError(error);
                });
              },
              error => {
                handleError(error);
              },
            );
          };

          function handleError(error) {
            $mdDialog.cancel({ action: 'ERROR', error });
            ErrorModal.show('Error generating student report', error);
          }

          $scope.download = () => {
            $window.open($scope.downloadUrl);
            $mdDialog.hide({ action: 'DOWNLOADED' });
          };

          $scope.close = () => {
            $mdDialog.cancel({ action: 'CLOSED' });
          };
        },
      });
    },
  };

  return StudentReportModal;
}
